import { type RootState } from '../../stores/redux';

export const getIsGalleryView = (state: RootState) => state.call.isGalleryView;

export const getIsSidebarOpen = (state: RootState) => state.call.isSidebarOpen;

export const getIsNoiseSuppressionEnabled = (state: RootState) =>
  state.call.isNoiseSuppressionEnabled;

export const getIsSpeakingWhileMutedSeen = (state: RootState) =>
  state.call.isSpeakingWhileMutedSeen;

export const getMainCallParticipantId = (state: RootState) =>
  state.call.mainCallParticipantId;

export const getPipCallParticipantId = (state: RootState) =>
  state.call.pipCallParticipantId;

export const getCallLayout = (state: RootState) =>
  state.call.isGalleryView ? 'gallery' : 'speaker';
